import React from 'react'
import { Button } from "@material-ui/core";

export default function Botonazulpampa({onClick,variant,text,disable ,style}) {
    const textColor = "#FCFCFC"
    const backgroundColor = "#0B3845"
    function jsonConcat(o1, o2) {
        for (var key in o2) {
         o1[key] = o2[key];
        }
        return o1;
       }
    const styles = jsonConcat({color:textColor,backgroundColor: backgroundColor },style)
    const unBoton = () =>{
        if(disable === true){
            return  <Button onClick={onClick} disabled variant={variant?variant:"contained"} style={style}>
                        {text?text:"Aceptar"}
                    </Button>
        }else{
            return  <Button onClick={onClick}  variant={variant?variant:"contained"} style={styles}>
                        {text?text:"Aceptar"}
                    </Button>
        }
    }
    return (
        unBoton()
    )
}
